import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import "./NewsLetter.css";
import slide1 from "../../assets/slide1.jpg";
import { Button } from "react-bootstrap";
import TranslatedLink from "../navigation/TranslatedLink";
import { RUTAS } from "../../constants/routes.constants";
import { postNewsLetter } from "../../api/contact";

const NewsLetter = ({ show, handleClose }) => {
  const [message, setMessage] = useState(null);

  if (!show) {
    return null;
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    const formDataObj = Object.fromEntries(formData.entries());

    postNewsLetter(formDataObj)
      .then((res) => {
        if (res.status === 201) {
          setMessage(<FormattedMessage id="NEWSLETTER.SUCCESS" />);
        }
      })
      .catch((error) => {
        setMessage(<FormattedMessage id="NEWSLETTER.ERROR" />);
      });
  };

  return (
    <div className="newsletter-overlay apercuregular" onClick={handleClose}>
      <div className="newsletter-modal" onClick={(e) => e.stopPropagation()}>
        <button className="close-btn" onClick={handleClose}>
          &times;
        </button>
        <div className="newsletter-content">
          <div className="left-section">
            <img src={slide1} alt="Newsletter" className="img-fluid" />
          </div>
          <div className="right-section d-flex flex-column justify-content-center gap-3">
            <h2 className="newsTitle align-self-center apercubold text-center brown">
              <span>
                <FormattedMessage id="NEWSLETTER.TITLE1" />
              </span>
              <br />
              <span>
                <FormattedMessage id="NEWSLETTER.TITLE2" />
              </span>
            </h2>
            <ul className="mb-4 list-unstyled">
              <li className="d-flex align-items-center">
                <svg
                  width="12"
                  height="12"
                  fill="currentColor"
                  className="bi bi-check-circle-fill"
                  viewBox="0 0 16 16"
                >
                  <path d="M16 8a8 8 0 1 1-16 0 8 8 0 0 1 16 0zM6.5 11.5L3 8l1.5-1.5L6.5 9 11 4.5 12.5 6 6.5 11.5z" />
                </svg>
                <span className="ml-2">
                  <FormattedMessage id="NEWSLETTER.CONTENT1" />
                </span>
              </li>
              <li className="d-flex align-items-center">
                <svg
                  width="12"
                  height="12"
                  fill="currentColor"
                  className="bi bi-check-circle-fill"
                  viewBox="0 0 16 16"
                >
                  <path d="M16 8a8 8 0 1 1-16 0 8 8 0 0 1 16 0zM6.5 11.5L3 8l1.5-1.5L6.5 9 11 4.5 12.5 6 6.5 11.5z" />
                </svg>
                <span className="ml-2">
                  <FormattedMessage id="NEWSLETTER.CONTENT2" />
                </span>
              </li>
              <li className="d-flex align-items-center">
                <svg
                  width="12"
                  height="12"
                  fill="currentColor"
                  className="bi bi-check-circle-fill"
                  viewBox="0 0 16 16"
                >
                  <path d="M16 8a8 8 0 1 1-16 0 8 8 0 0 1 16 0zM6.5 11.5L3 8l1.5-1.5L6.5 9 11 4.5 12.5 6 6.5 11.5z" />
                </svg>
                <span className="ml-2">
                  <FormattedMessage id="NEWSLETTER.CONTENT3" />
                </span>
              </li>
            </ul>
            <form onSubmit={handleSubmit} className="w-100">
              <div className="form-group mb-4">
                <input
                  type="email"
                  className="form-control"
                  placeholder="Email address"
                  name="email"
                />
              </div>
              <div className="form-group mb-4 d-flex gap-3 align-items-center">
                <input
                  type="checkbox"
                  id="privacyPolicy"
                  name="privacyPolicy"
                  required
                />
                <label htmlFor="privacyPolicy" className="m-0">
                  <FormattedMessage id="NEWSLETTER.POLITICAPRIVACIDAD1" />{" "}
                  <TranslatedLink to={RUTAS.PRIVACIDAD} target="_blank">
                    <b>
                      <u>
                        <FormattedMessage id="NEWSLETTER.POLITICAPRIVACIDAD2" />
                      </u>
                      <div />
                    </b>
                  </TranslatedLink>
                </label>
              </div>
              <div className="text-center w-100">
                <button type="submit" className="subscribe-btn w-100">
                  <FormattedMessage id="NEWSLETTER.SIGNUPBUTTON" />{" "}
                </button>
              </div>
            </form>
            <div className="text-center p-2">
              <b>{message}</b>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsLetter;
